import { supabase } from '../config/supabase';

export const directoryService = {
  async getItems(type = null) {
    let query = supabase
      .from('hahub_directory_items')
      .select(`
        *,
        translations:hahub_directory_translations(*)
      `)
      .eq('status', 'published');

    if (type) {
      query = query.eq('type', type);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data;
  },

  getMockDirectory() {
    return [
      {
        id: 'd1',
        type: 'hospital',
        name: { en: 'Athens Medical Center', el: 'Ιατρικό Κέντρο Αθηνών' },
        description: { en: 'Leading cancer treatment facility.', el: 'Κορυφαία μονάδα θεραπείας καρκίνου.' },
        is_verified: true
      },
      {
        id: 'd2',
        type: 'organization',
        name: { en: 'Cancer Support Greece', el: 'Υποστήριξη Καρκίνου Ελλάδας' },
        description: { en: 'NGO providing emotional support.', el: 'ΜΚΟ που παρέχει συναισθηματική υποστήριξη.' },
        is_verified: true
      }
    ];
  }
};